module.exports = __webpack_public_path__ + "img/half_alpha.1588e218.png";